import { useShareChannels } from 'src/app/pages/psf/share/shared/hooks';
import { useAvailableShareActions } from 'src/app/shared/hooks/share';

import { useShareOptions } from './options';

export function usePsfShareAvailableShareActions() {
	const options = useShareOptions();
	const channels = useShareChannels();
	return useAvailableShareActions(channels, options);
}
